<template lang="html">

    <div class="cover-popup row-center" v-if="mostrar">
      <div class="popup">

  
        <h2 class="title-pop">{{$t('popup_datos_personales.atencion')}}</h2>

        <p>{{$t('popup_datos_personales.titulo')}}</p>
  
        <div class="contenedor-botones">
  
          <router-link :to="$t('enlaces.cv')" class="btn -solid-primary">{{$t('popup_datos_personales.ir_a_perfil')}}</router-link>
  
        </div>
  
      </div>
    </div>
  
  </template>
  
  <script lang="js">
    
      import {mapGetters,mapActions} from 'vuex';
    
      export default  {
        name: 'popup-faltan-datos-personales',
        mounted(){
            if(this.mostrar){
              this.request();
            }
        },
        computed : {
          ...mapGetters({
            brand:'getBrand',
            style : 'getStyles',
            mostrar : 'getfaltanDatosPersonalesObligatorios',
            
          })
        },
        methods : {
          ...mapActions(['checkDatosPersonalesObligatorios']),
          request(){
            this.checkDatosPersonalesObligatorios();
          }
        }
      }
    </script>
  <style scoped lang="scss">
  
    
    
    </style>


// WEBPACK FOOTER //
// submodules/dotia-base-fp/src/components/parts/popup-rellenar-datos-personales.vue